(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire637e"];
var parcelRegister = parcelRequire.register;
parcelRegister("dQcqH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a139c5f71097989c$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");

var $6MRuB = parcelRequire("6MRuB");
var $a139c5f71097989c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Search(param) {
        var el = param.el;
        (0, $J7ygF._)(this, Search);
        this.el = el;
        this.form = this.el.querySelector("form");
        this.input = this.form.querySelector('input[type="search"]');
        this.closer = this.el.querySelector(".search-closer");
        this.openers = Array.from(document.querySelectorAll(".search-opener"));
        // this el has to be outside of the header for mix blend mode to work as expected
        this.results = document.querySelector("#predictive-search-container .results");
        this.init();
    }
    (0, $hvJJn._)(Search, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.openers.forEach(function(opener) {
                    opener.addEventListener("click", function() {
                        _this.open();
                    });
                });
                this.input.addEventListener("input", this.debounce(function(event) {
                    _this.onChange(event);
                }, 300).bind(this));
                this.closer.addEventListener("click", function() {
                    _this.close();
                });
            }
        },
        {
            key: "onChange",
            value: function onChange() {
                var searchTerm = this.input.value.trim();
                this.getSearchResults(searchTerm);
            }
        },
        {
            key: "getSearchResults",
            value: function getSearchResults(searchTerm) {
                var _this = this;
                // if search term empty, hide results and show suggested searches
                if (!searchTerm.length) {
                    this.el.classList.remove("search-in-progress");
                    return;
                }
                // if there is a search term, show results
                this.el.classList.add("search-in-progress");
                this.results.innerHTML = '<div class="loading px-base text-sm uppercase font-secondary flex justify-center"><p>Loading...</p></div>';
                fetch("/search/suggest?q=".concat(searchTerm, "&resources[type]=product,page,article,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=hide&section_id=predictive-search")).then(function(response) {
                    if (!response.ok) {
                        var error = new Error(response.status);
                        _this.close();
                        throw error;
                    }
                    return response.text();
                }).then(function(text) {
                    var resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
                    _this.results.innerHTML = resultsMarkup;
                // this.open();
                }).catch(function(error) {
                    _this.close();
                    throw error;
                });
            }
        },
        {
            key: "open",
            value: function open() {
                document.body.style.overflow = "hidden";
                this.input.value = "";
                (0, $6MRuB.emitter).emit("cart:close");
                document.body.classList.remove("show-cart");
                document.body.classList.add("search-active");
                this.input.focus();
            }
        },
        {
            key: "close",
            value: function close() {
                var _this = this;
                document.body.style.overflow = "initial";
                document.body.classList.remove("search-active");
                setTimeout(function() {
                    _this.input.value = "";
                }, 350);
            }
        },
        {
            key: "debounce",
            value: function debounce(fn, wait) {
                var _this = this;
                var t;
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    clearTimeout(t);
                    t = setTimeout(function() {
                        return fn.apply(_this, args);
                    }, wait);
                };
            }
        }
    ]);
    return Search;
}();

});

})();
//# sourceMappingURL=Search.08eba46b.js.map
